import {Vue} from '~/addiesaas'
// shop/orders is an container path alias set using /resources/js/lib/aliaser
import CartMixin from 'shop/orders/_mixins/cart'
//GETTERS: cartItemStub, cart:state, cartItems, cartDiscounts, cartItemCount, cartIsEmpty, cartItem(id), billingDetails(id)
//ACTIONS: addCartItem,addCartItems,addDiscount,removeCartDiscount,clearCart,removeCartItem,setBillingDetails

import {formatPrice, pushState} from '../../lib/utils'

const EventBus = window.VueEventBus

export default {
  data() {
    return {
      timerWarningType: 'warning'
    }
  },
  mixins: [CartMixin],
  created() {

    EventBus.$on('timer.timeout', (id) => {
      if (id === this.currentLocationId) {
        Vue.set(this, 'timerWarningType', 'danger')
      }
    })
    EventBus.$on('timer.tick', (remaining, id) => {
      if (id === this.currentLocationId && remaining <= 60) {
        Vue.set(this, 'timerWarningType', 'danger')
      } else {
        Vue.set(this, 'timerWarningType', 'warning')
      }
    })
  },
  mounted() {
  },
  methods: {
    cartHasItemOfType(type) {
      return _.some(this.currentCartItems, {type})
    },
  },
  computed: {
    timerStatus() {
      return this.needsToShowTimer && this.timerIsRunning ?
        `Time to complete your purchase: ${this.timerRemainingFormatted}` : ''
    },
    formatPrice(value, decimals = 2, truncateZeroDecimals = true) {
      return formatPrice(value, decimals, truncateZeroDecimals)
    },
    openMyCart() {
      //this.$router.push({name: 'racewaybooking.checkout'})
    }
  }
}

